const getDomain = () => {
  const { hostname } = window.location

  if (hostname.endsWith('foregon.com')) return 'foregon.com'
  if (hostname.endsWith('davi.com.br')) return '.davi.com.br'
  return hostname
}

const cookie = {
  set: (
    name,
    value,
    seconds = 365 * 24 * 60 * 60,
    path = '/',
    domain = getDomain(),
  ) => {
    const expires = new Date(Date.now() + seconds * 1000).toUTCString()
    let cookieStr = `${name}=${value}; expires=${expires}; domain=${domain}; path=${path}`

    // ✅ Inclui SameSite e Secure automaticamente para domínios davi.com.br
    if (domain === '.davi.com.br') {
      cookieStr += `; SameSite=None; Secure`
    }

    document.cookie = cookieStr
  },

  get: (name) => {
    const value = `; ${document.cookie}`
    const parts = value.split(`; ${name}=`)
    if (parts.length === 2) {
      return parts.pop().split(';').shift()
    }
    return null
  },

  delete: (name, domain = getDomain()) => {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; domain=${domain}; path=/`
  },
}

export default cookie
